import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { cn } from "@/utils/cn";

interface SidebarEdgeToggleProps {
  collapsed: boolean;
  onToggle: () => void;
  /** Fixed tab for mobile when the sidebar is fully off-screen */
  variant?: "rail" | "mobile";
}

export function SidebarEdgeToggle({
  collapsed,
  onToggle,
  variant = "rail",
}: SidebarEdgeToggleProps) {
  const isMobile = variant === "mobile";
  const label = collapsed ? "Open sidebar" : "Close sidebar";

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      title={label}
      className={cn(
        "workspace-sidebar-edge-toggle",
        collapsed
          ? "workspace-sidebar-edge-toggle--expand"
          : "workspace-sidebar-edge-toggle--collapse",
        isMobile && "workspace-sidebar-edge-toggle--mobile",
      )}
    >
      {collapsed ? (
        <ChevronRightIcon sx={{ fontSize: 18 }} />
      ) : (
        <ChevronLeftIcon sx={{ fontSize: 18 }} />
      )}
    </button>
  );
}
